export const SITE = {
  name: "BoxB Solutions",
  tagline: "Moving Made Simple.",
  phone: "+44 7570 291363",
  phoneRaw: "+447570291363",
  whatsappNumber: "447570291363",
  email: "info@boxb.uk",
  website: "https://www.boxb.uk",
  location: "Cardiff, South Wales, UK",
};

export const waLink = (message) => {
  const text = encodeURIComponent(message || "Hello BoxB Solutions, I would like to get a quotation.");
  return `https://wa.me/${SITE.whatsappNumber}?text=${text}`;
};

export const telLink = `tel:${SITE.phoneRaw}`;
export const mailLink = `mailto:${SITE.email}`;
